module.exports = __webpack_public_path__ + "static/media/78.51f2657a.jpg";